import colors from "./colors";

const fonts = {
  //** presentation */
  presentation_thumb_number: `
    font: Bold 11px Noto Sans KR;
  `,

  //** H1 */
  H1_Bold: `Font-size: 22px; line-height: 1.65em; Font-weight: 700; color: ${colors.C000000};`,
  H1_Regular: `Font-size: 22px; line-height: 1.65em; Font-weight: 400; color: ${colors.C000000};`,
  H1_White: `Font-size: 22px; line-height: 1.65em; Font-weight: 700; color: ${colors.CFFFFFF};`,

  //** H2 */
  H2_Bold: `Font-size: 18px; line-height: 1.65em; Font-weight: 700; color: ${colors.C000000};`,
  H2_White: `Font-size: 18px; line-height: 1.65em; Font-weight: 700; color: ${colors.CFFFFFF};`,
  H2_Regular: `Font-size: 18px; line-height: 1.65em; Font-weight: 400; color: ${colors.C000000};`,
  
  //** H3 */

  H3_Regular: `Font-size: 14px; line-height: 1.65em; Font-weight: 400; color: ${colors.C000000};`,
  H3_White: `Font-size: 14px; line-height: 1.65em; Font-weight: 400; color: ${colors.CFFFFFF};`,
  H3_Green: `Font-size: 14px; line-height: 1.65em; Font-weight: 700; color: ${colors.C41F0CD};`,
  H3_DimGreen: `Font-size: 14px; line-height: 1.65em; Font-weight: 400; color: ${colors.C41F0CD};`,

  //** H4 */
  H4: `Font-size: 11px; line-height: 7.76em; Font-weight: 400; color: ${colors.C474747};`,

}

export default fonts;